var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-overlay', {
    staticClass: "w-100 h-100",
    attrs: {
      "show": _vm.loading,
      "spinner-variant": "primary",
      "spinner-type": "grow"
    }
  }, [_c('b-container', {
    staticClass: "align-content-start d-flex",
    attrs: {
      "fluid": ""
    }
  }, [_c('create-sheet-form', {
    attrs: {
      "sheet": _vm.sheet,
      "error": _vm.error
    },
    on: {
      "submit": _vm.onSubmit
    }
  })], 1), _c('confirmation-modal', {
    attrs: {
      "id": "update-name-modal",
      "title-key": "sheet.popup.update-name.title"
    },
    on: {
      "on-click-yes": _vm.onUpdate
    },
    scopedSlots: _vm._u([{
      key: "body-text",
      fn: function fn() {
        var _vm$newItem;

        return [_c('p', {
          staticClass: "mb-3 text-center"
        }, [_vm._v(" " + _vm._s(_vm.$t('sheet.popup.update-name.message', {
          name: _vm.sheet.name,
          newName: (_vm$newItem = _vm.newItem) === null || _vm$newItem === void 0 ? void 0 : _vm$newItem.name
        })) + " ")])];
      },
      proxy: true
    }])
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }